import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { ConfirmModal } from "../../../components/ConfirmModal";
import { getImgSrc, getPlatformImg } from "../../../helpers/getImgSrc";
import LoadingSpinner from "../../../components/client/LoadingSpinner";
import {
  getAccountStatus,
  getExternalCampaigns,
  getUserCampaignList,
  getPlatformList,
  listCampaignAds,
  updateCampaignAssociateStatus,
} from "../../../services/ApiService";
import {
  getPlatformName,
  getPlatformNameOrId,
} from "../../../helpers/getPlatformName";
import { toast } from "react-toastify";
import { handleApi } from "../../../utils/authentication";
import { useSelector } from "react-redux";
import HeaderComponent from "../../../components/client/integrations/header_component/HeaderComponent";
import { Link } from "react-router-dom";
import "./link_organic_social.css";

const LinkOrganicSocial = () => {
  const [platforms, setPlatforms] = useState([]);
  const [pages, setPages] = useState([]);
  const [pagePosts, setPagePosts] = useState([]);
  const [programs, setPrograms] = useState(null);
  const [campaigns, setCampaigns] = useState(null);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [selectedProgram, setSelectedProgram] = useState(null);
  const [campaignsByProgram, setCampaignsByProgram] = useState({});
  const [selectedPlatform, setSelectedPlatform] = useState(null);
  const [selectedPage, setSelectedPage] = useState(null);
  const [selectedPagePost, setSelectedPagePost] = useState(null);
  const [paging, setPaging] = useState({
    next: "",
    previous: "",
  });
  const [currentPostsPage, setCurrentPostsPage] = useState({
    next: "",
    previous: "",
  });

  const filter = useSelector((state) => state?.filter);
  const user = useSelector((state) => state?.user);

  const [loading, setLoading] = useState({
    platform: true,
    campaigns: false,
    pages: false,
    posts: false,
    program: true,
    linkAction: false,
  });

  const [linkActionConfirmModal, setLinkActionConfirmModal] = useState(false);

  // Pick the connected platform the user asked for, falling back to the first
  // connected one so the header card / pages list always have real data.
  const resolvePlatform = (platform_list, preferred_platform_id) => {
    if (!platform_list?.length) {
      return null;
    }
    const preferred = platform_list.find(
      (platform) => platform?.platform_id == preferred_platform_id,
    );
    return preferred || platform_list[0];
  };

  const selectPlatform = (platform) => {
    if (!platform) {
      return;
    }
    setSelectedPlatform({
      ...platform?.account_details,
      ...platform,
      social_media_type: "organic_social",
    });
  };

  const fetchPlatformsList = async () => {
    setLoading((prev) => ({ ...prev, platform: true }));
    let formData = null;
    let result = await handleApi(
      `get_organic_platform_list`,
      "GET",
      {},
      formData,
    );
    if (result?.success) {
      // Convert the object to an array of platform objects
      const platformList = Object.values(result?.platforms)
        .filter((platform) => platform.is_account_linked)
        .map((platform) => platform);
      setPlatforms(platformList);

      // Prefer the record from the API (it carries account_details, so the
      // header card can render), but keep falling back to the redux selection
      // so the page still works when the list comes back empty.
      selectPlatform(
        resolvePlatform(
          platformList,
          filter?.select_organic_social_platform?.platform_id,
        ) || filter?.select_organic_social_platform,
      );
    }

    setLoading((prev) => ({ ...prev, platform: false }));
  };

  const fetchProgramList = async () => {
    setLoading((prev) => ({ ...prev, program: true }));
    let formData = new FormData();
    formData.append("client_id", user?.client_id);
    formData.append("role_id", user?.role_id);
    let result = await handleApi(`program_list`, "POST", {}, formData);
    if (result?.success) {
      // Convert the object to an array of platform objects
      setPrograms(result?.data?.programs_list);
    }
    setLoading((prev) => ({ ...prev, program: false }));
  };

  const fetchPagePosts = async (pointer = "", currentPage) => {
    setLoading((prev) => ({ ...prev, pagePosts: true }));
    let formData = new FormData();
    formData.append("platform_id", selectedPlatform?.platform_id);
    formData.append("page_id", selectedPage?.page_id);

    if (pointer != "" && currentPage != "") {
      formData.append(pointer, currentPage);
    }

    let result = await handleApi(
      `fetch_and_store_posts_list`,
      "POST",
      {},
      formData,
    );
    if (result?.success) {
      // setPagePosts(result?.data || []);

      // setPagePosts(result?.data);

      setPagePosts((prevPosts) => {
        const seen = new Set();
        const mergedPosts = [...prevPosts, ...result.data];

        const uniquePosts = mergedPosts.filter((post) => {
          if (seen.has(post.post_id)) {
            return false;
          } else {
            seen.add(post.post_id);
            return true;
          }
        });

        return uniquePosts;
      });

      setPaging(result?.page_data);
    } else {
      setPagePosts([]);
    }
    setLoading((prev) => ({ ...prev, pagePosts: false }));
  };

  useEffect(() => {
    fetchPlatformsList();
    fetchProgramList();
  }, []);

  const fetchPagesList = async () => {
    setLoading((prev) => ({ ...prev, pages: true }));
    let formData = new FormData();
    formData.append("platform_id", selectedPlatform?.platform_id);
    let result = await handleApi(
      `fetch_and_store_pages_list`,
      "POST",
      {},
      formData,
    );
    if (result?.success) {
      setPages(result?.data || []);
    } else {
      setPages([]);
    }
    setLoading((prev) => ({ ...prev, pages: false }));
  };

  useEffect(() => {
    if (selectedPlatform) {
      fetchPagesList();
    }
  }, [selectedPlatform]);

  useEffect(() => {
    if (selectedPage) {
      setSelectedPagePost(null);
      setPagePosts([]);
      fetchPagePosts();
    }
  }, [selectedPage]);

  // useEffect(()=>{
  //      if (selectedPage) {
  //     fetchPagePosts();
  //   }

  // },[currentPostsPage])

  const handlePlatformSelect = (platform_id) => {
    const platform =
      resolvePlatform(
        platforms,
        platform_id ?? filter?.select_organic_social_platform?.platform_id,
      ) || filter?.select_organic_social_platform;

    selectPlatform(platform);
    setSelectedPagePost(null);
    setSelectedPage(null);
  };

  useEffect(() => {
    if (filter?.select_organic_social_platform && platforms?.length > 0) {
      handlePlatformSelect();
    }
  }, [filter?.select_organic_social_platform, platforms]);

  const fetchCampaignList = async (programId, postId = undefined) => {
    try {
      setLoading((prev) => ({ ...prev, campaigns: true }));
      let formData = new FormData();
      formData.append("program_id", programId);
      formData.append("user_id", user?.user_id);
      const post_id = postId ?? selectedPagePost?.post_id;
      if (post_id) {
        formData.append("post_id", post_id);
      }

      let result = await handleApi(
        `get_organic_post_campaign_list`,
        "POST",
        {},
        formData,
      );
      if (result?.success) {
        setCampaignsByProgram((prev) => ({
          ...prev,
          [programId]: result?.data || [],
        }));
      } else {
        setCampaignsByProgram((prev) => ({ ...prev, [programId]: [] }));
      }
    } catch (e) {
      console.log(e);
      setCampaignsByProgram((prev) => ({ ...prev, [programId]: [] }));
    } finally {
      setLoading((prev) => ({ ...prev, campaigns: false }));
    }
  };

  const handleProgramSelect = (program) => {
    // Programs sit alongside Pages/Posts now, so picking one must not reset
    // the page/post the user already selected.
    const isSame = selectedProgram?.program_id === program?.program_id;
    setSelectedProgram(isSame ? null : program);

    if (!isSame) {
      // Refetch rather than reuse the cache: is_mapped depends on the selected post.
      fetchCampaignList(program?.program_id);
    }
  };

  const handlePostSelect = (post) => {
    setSelectedPagePost(post);

    if (selectedProgram?.program_id) {
      fetchCampaignList(selectedProgram.program_id, post?.post_id);
    }
  };

  // The Link button lives on the campaign row; the post selected in the Posts
  // column is what gets linked to that campaign's program.
  const handleCampaignLinkAction = (campaign) => {
    if (!selectedPagePost) {
      toast.error("Please select a post first.");
      return;
    }
    setSelectedCampaign(campaign);
    setLinkActionConfirmModal(true);
  };

  const handlePageSelet = (page) => {
    setSelectedPage(page);
    setSelectedPagePost(null);
    setPagePosts([]);
  };

  const trackPostMetricsStatus = async () => {
    try {
      setLoading((prev) => ({ ...prev, linkAction: true }));
      const formData = new FormData();
      formData.append("post_id", selectedPagePost.post_id);
      formData.append("is_mapped", selectedPagePost.is_mapped);
      formData.append("client_id", user?.client_id);
      formData.append("program_id", selectedProgram?.program_id);
      formData.append("platform_id", selectedPlatform?.platform_id);
      formData.append("campaign_id", selectedCampaign?.campaign_id);

      let result = await handleApi(
        `link_internal_program_with_organic_post`,
        "POST",
        {},
        formData,
      );
      if (result?.success) {
        if (selectedPagePost.is_mapped) {
          toast.success(
            "The organic post has been successfully unlinked from the internal program.",
          );
        } else {
          toast.success(
            "The organic post has been successfully linked to the internal program.",
          );
        }

        setLinkActionConfirmModal(false);
        // fetchPagePosts();

        setPagePosts((prevPosts) =>
          prevPosts.map((post) =>
            post.post_id === selectedPagePost.post_id
              ? { ...post, is_mapped: selectedPagePost?.is_mapped == 0 ? 1 : 0 }
              : post,
          ),
        );

        // The Link/UnLink button reads the selected post, so it has to be
        // toggled too — otherwise the label only updates after a reload.
        setSelectedPagePost((prev) =>
          prev ? { ...prev, is_mapped: prev?.is_mapped == 0 ? 1 : 0 } : prev,
        );

        if (selectedProgram?.program_id) {
          fetchCampaignList(selectedProgram.program_id, selectedPagePost.post_id);
        }

        setSelectedPlatform((prev) => {
          const currentCount = prev?.total_posts_linked || 0;

          if (selectedPagePost?.is_mapped && currentCount > 0) {
            return { ...prev, total_posts_linked: currentCount - 1 };
          } else if (!selectedPagePost?.is_mapped) {
            return { ...prev, total_posts_linked: currentCount + 1 };
          }

          // If no change is needed, return prev as-is
          return prev;
        });
      } else {
        toast.error("Something went wrong; please try again later.");
      }
      setLoading((prev) => ({ ...prev, linkAction: false }));
    } catch (e) {
      console.log(e);
      toast.error(e?.message);
    }
  };

  //linkedin only
  const checkIsUgcPost = () => {
    try {
      if (
        selectedPagePost?.post_id &&
        selectedPagePost?.post_id.includes("urn:li:ugcPost:")
      ) {
        return (
          <p>
            <b>Note:</b> Only the person who manages this LinkedIn page can see
            the performance of user-generated posts.
          </p>
        );
      }
      return "";
    } catch (e) {
      console.log(e);
    }
  };

  // Columns appear one at a time: a page reveals Posts, a post reveals
  // Programs, a program reveals Campaigns. Widths always add up to 12.
  const show_posts = !!selectedPage;
  const show_programs = !!selectedPagePost;
  const show_campaigns = !!selectedProgram;
  const pages_width = show_posts ? "3" : "12";
  const posts_width = show_programs ? (show_campaigns ? "3" : "6") : "9";

  return (
    <div className="d-flex flex-column">
      <HeaderComponent
        platform_id={selectedPlatform?.platform_id}
        is_account_linked={selectedPlatform?.is_account_linked}
        account_name={selectedPlatform?.account_details?.account_name}
        created_at={selectedPlatform?.account_details?.created_at}
        total_ads_linked={
          selectedPlatform?.social_media_type === "organic_social"
            ? selectedPlatform?.total_posts_linked
            : selectedPlatform?.total_ads_linked
        }
        media_type={selectedPlatform?.social_media_type}
      />

      <div className="row">
        <div className="col-12">
          <div
            className="d-flex"
            style={{ minHeight: "80vh", maxHeight: "80vh" }}
          >
            {/* Column 1: Social Media Platforms */}
            <div
              className={`col-md-${selectedPlatform ? "2" : "12"} col-12 pe-3 ${
                selectedPlatform && "border_end"
              } overflow-y-auto position-relative d-none`}
            >
              {loading.platform ? (
                <div
                  className="d-flex justify-content-center align-items-center position-absolute top-50 start-50 translate-middle"
                  style={{ minHeight: "100%" }}
                >
                  <LoadingSpinner />
                </div>
              ) : (
                <div>
                  <h5>Platforms</h5>
                  <span className="small">Conected platforms</span>
                  <ul className="p-0 mt-3 border_top">
                    {platforms?.length > 0 ? (
                      platforms.map((platform) => (
                        <li
                          key={platform?.platform_id}
                          className={`border_bottom p-3 ${
                            selectedPlatform === platform?.platform_id
                              ? "text_primary bg_primary_light"
                              : ""
                          }`}
                          onClick={() =>
                            handlePlatformSelect(platform?.platform_id)
                          }
                          style={{ cursor: "pointer" }}
                        >
                          <div className="w-100 d-flex align-items-center gap-2 flex-start">
                            <img
                              src={getPlatformImg(platform?.platform_id)}
                              className="img-fluid social_media_img"
                              alt=""
                            />
                            <span className="small">
                              {getPlatformName(platform?.platform_id)}
                            </span>
                          </div>
                        </li>
                      ))
                    ) : (
                      <span>No platforms found</span>
                    )}
                  </ul>
                </div>
              )}
            </div>

            {/* Column 2: Pages */}
            {selectedPlatform && (
              <div
                className={`col-md-${pages_width} col-12 ${
                  show_posts ? "border_end" : ""
                } overflow-y-auto p-3 position-relative`}
              >
                {loading.pages ? (
                  <div
                    className="d-flex justify-content-center align-items-center position-absolute top-50 start-50 translate-middle"
                    style={{ minHeight: "100%" }}
                  >
                    <LoadingSpinner />
                  </div>
                ) : (
                  <div>
                    <h5>Pages</h5>
                    <span className="small">
                      {`Here are the list of pages you can link to the given ${getPlatformName(
                        selectedPlatform?.platform_id,
                      )} account`}
                    </span>
                    {pages?.length > 0 ? (
                      <ul className="p-0 mt-3 border_top">
                        {pages.map((page) => (
                          <li
                            key={page?.page_id}
                            className={`border_bottom p-3 ${
                              selectedPage?.page_id === page?.page_id
                                ? "text_primary bg_primary_light"
                                : ""
                            }`}
                            onClick={() => handlePageSelet(page)}
                            style={{ cursor: "pointer" }}
                          >
                            <div className="w-100 text-start small">
                              {page?.page_name}
                            </div>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p className="mt-3">No Pages available.</p>
                    )}
                  </div>
                )}
              </div>
            )}

            {/* Column 3: Posts */}
            {selectedPage && (
              <div
                className={`col-md-${posts_width} col-12 ${
                  show_programs ? "border_end" : ""
                } overflow-y-auto p-3 position-relative`}
              >
                <h5>Posts</h5>
                <span className="small">
                  {`Here are the posts associated with the ${
                    selectedPage?.page_name !== ""
                      ? selectedPage?.page_name
                      : "selected page"
                  }.`}
                </span>
                <div className="mt-3 border_top">
                  {pagePosts.length > 0 ? (
                    <ul className="p-0">
                      {pagePosts.map((post) => (
                        <li
                          key={post?.post_id}
                          className={`border_bottom p-3 ${
                            selectedPagePost?.post_id === post?.post_id
                              ? "bg_primary_light"
                              : ""
                          }`}
                          onClick={() => handlePostSelect(post)}
                          style={{ cursor: "pointer" }}
                        >
                          <div className="row g-3">
                            <div className="col-md-3">
                              <div
                                className="rounded-2 custom_border"
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  height: "150px",
                                  overflow: "hidden",
                                }}
                              >
                                <img
                                  src={
                                    post?.image_url
                                      ? post?.image_url
                                      : getImgSrc("no_image_found", "png")
                                  }
                                  alt=""
                                  style={{
                                    width: "100%",
                                    height: "auto",
                                    objectFit: "cover",
                                  }}
                                />
                              </div>
                            </div>

                            <div className="col-md-9">
                              <div className="small text_color_tertiary content_wrap">
                                {post?.message || "---"}
                              </div>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  ) : !loading.pagePosts ? (
                    <p>No Posts available.</p>
                  ) : (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ minHeight: "5rem" }}
                    >
                      <LoadingSpinner />
                    </div>
                  )}
                  {paging?.next && paging?.next !== "" && (
                    <span
                      onClick={() =>
                        !loading.pagePosts &&
                        fetchPagePosts("next", paging?.next)
                      }
                      className="btn btn-sm rounded-pill d-flex align-items-center gap-2"
                      style={{
                        cursor: loading.pagePosts ? "not-allowed" : "pointer",
                        opacity: loading.pagePosts ? 0.6 : 1,
                      }}
                    >
                      <span>Next</span>
                    </span>
                  )}
                </div>
              </div>
            )}

            {/* Column 4: Programs */}
            {show_programs && (
              <div className="col-md-3 col-12 overflow-y-auto p-3 position-relative">
                {loading.program ? (
                  <div
                    className="d-flex justify-content-center align-items-center position-absolute top-50 start-50 translate-middle"
                    style={{ minHeight: "100%" }}
                  >
                    <LoadingSpinner />
                  </div>
                ) : (
                  <div>
                    <h5>Programs</h5>
                    <span className="small">Programs List</span>
                    {programs?.length > 0 ? (
                      <ul className="p-0 mt-3 border_top">
                        {programs.map((program) => (
                          <li
                            key={program?.program_id}
                            className={`border_bottom p-3 ${
                              selectedProgram?.program_id ===
                              program?.program_id
                                ? "text_primary bg_primary_light"
                                : ""
                            }`}
                            onClick={() => handleProgramSelect(program)}
                            style={{ cursor: "pointer" }}
                          >
                            <div className="w-100 text-start small">
                              {program?.program_name}
                            </div>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p className="mt-3">
                        No Programs available.{" "}
                        <Link
                          to="/client/programs"
                          style={{ textDecoration: "none" }}
                        >
                          Create Program
                        </Link>
                      </p>
                    )}
                  </div>
                )}
              </div>
            )}

            {/* Column 5: Campaigns */}
            {show_campaigns && (
              <div className="col-md-3 col-12 border_start overflow-y-auto p-3 position-relative">
                {loading.campaigns ? (
                  <div
                    className="d-flex justify-content-center align-items-center position-absolute top-50 start-50 translate-middle"
                    style={{ minHeight: "100%" }}
                  >
                    <LoadingSpinner />
                  </div>
                ) : (
                  <div>
                    <h5>Campaigns</h5>
                    <span className="small">{`Here are the list of campaigns you can link to the given ${selectedProgram?.program_name} program`}</span>
                    {campaignsByProgram[selectedProgram?.program_id]?.length >
                    0 ? (
                      <ul className="p-0 mt-3 border_top">
                        {campaignsByProgram[selectedProgram?.program_id].map(
                          (campaign) => (
                            <li
                              key={campaign?.campaign_id}
                              className="border_bottom p-3"
                            >
                              <div className="d-flex justify-content-between align-items-center gap-2">
                                <span className="small">
                                  {campaign?.campaign_name}
                                </span>
                                <button
                                  className={`btn btn-sm rounded-pill ${
                                    campaign?.is_mapped
                                      ? "btn-danger"
                                      : "btn-primary"
                                  }`}
                                  onClick={() =>
                                    handleCampaignLinkAction(campaign)
                                  }
                                  style={{ width: "70px" }}
                                  disabled={loading.linkAction}
                                >
                                  {campaign?.is_mapped ? "UnLink" : "Link"}
                                </button>
                              </div>
                            </li>
                          ),
                        )}
                      </ul>
                    ) : (
                      <p className="mt-3">No campaigns available.</p>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Confirmation Modal */}
      <ConfirmModal
        show={linkActionConfirmModal}
        loadingOnsubmit={loading.linkAction}
        onClose={() => setLinkActionConfirmModal(false)}
        onSubmit={trackPostMetricsStatus}
        title={selectedPagePost?.is_mapped ? "UnTrack Post" : "Track Post"}
        body={
          selectedPagePost?.is_mapped ? (
            "Would you like to untrack this post? It will be removed from your tracking list?"
          ) : (
            <>
              {" "}
              <p className="m-0">
                Would you like to track this post? It will be added to your
                tracking list for easy reference.
              </p>{" "}
              {checkIsUgcPost()}{" "}
            </>
          )
        }
      />
    </div>
  );
};

export default LinkOrganicSocial;
